import styles from './Grid.module.scss';
import type { ReactNode } from 'react';
import classNames from 'classnames';

type ColSize = 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type Props = {
  size?: ColSize;
  className?: string;
  children?: ReactNode;
};

const Col = ({ size, className, ...props }: Props) =>
  <div className={classNames(className, getSizeClassName(size))} {...props} />;

export default Col;

function getSizeClassName(size?: ColSize): string {
  const stylesDic = styles as Record<string, string>;

  if (!size)
      return stylesDic.col;

  if (size === 'auto')
    return stylesDic.colAuto;

  return stylesDic[`col${size}`];
}
